var Alberta = "アルバータ";
var Manitoba = "マニトバ";
var Nunavut = "ヌナブト";
var Ontario = "オンタリオ";
var Quebec = "ケベック";
var Saskatchewan = "サスカチュワン";
var Yukon = "ユーコン";
var CAStates = {
	Alberta: Alberta,
	"British Columbia": "ブリティッシュコロンビア",
	Manitoba: Manitoba,
	"New Brunswick": "ニューブランズウィック",
	"Newfoundland and Labrador": "ニューファンドランド・ラブラドール",
	"Northwest Territories": "ノースウエスト準州",
	"Nova Scotia": "ノバスコシア",
	Nunavut: Nunavut,
	Ontario: Ontario,
	"Prince Edward Island": "プリンスエドワードアイランド",
	Quebec: Quebec,
	Saskatchewan: Saskatchewan,
	Yukon: Yukon
};

export { Alberta, Manitoba, Nunavut, Ontario, Quebec, Saskatchewan, Yukon, CAStates as default };
